import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WifiOff, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FullPageMessage } from "@/components/FullPageMessage";

export default function Offline() {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleRetry = () => {
    if (isOnline) {
      window.location.reload();
    }
  };

  return (
    <>
      {/* ux-consistency: loading/empty C */}
      <FullPageMessage
        icon={WifiOff}
        title={t("offline.title")}
        subtitle={t("offline.description")}
        action={
          isOnline ? (
            <Button onClick={handleRetry} className="w-full">
              <RefreshCw className="mr-2 h-4 w-4" />
              {t("offline.retry")}
            </Button>
          ) : (
            <p className="text-sm text-muted-foreground">{t("offline.checkConnection")}</p>
          )
        }
      />
    </>
  );
}
